<section class="autoatencionFirstScreen">
  <div class="container">
    <div class="sup_title" i18n>AUTOATENCIÓN HOSTING</div>
    <h1 class="title1" i18n>
      LO QUE NECESITAS <br>
      A UN PAR DE CLICS!
    </h1>
  </div>
</section>
